"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultTokenCache = void 0;
const guard_1 = require("../utils/guard");
const utils_1 = require("../resilience/utils");
/**
 * The default token cache implementation.
 */
class DefaultTokenCache {
    /**
     * Initializes a new instance of the @see DefaultTokenCache class.
     * @param provider Provider for the tokens.
     * @param logger Logger to use.
     */
    constructor(provider, logger) {
        guard_1.Guard.throwIfNullOrEmpty(provider, 'provider');
        this.provider = provider;
        this.logger = logger;
    }
    /**
     * Gets an access token.
     */
    getToken(requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.trace(requestId, `Requesting token from cache`, null, utils_1.logFormatter);
            if (!this.token || this.hasExpired(this.token)) {
                this.logger.warning(requestId, `Token in cache empty or expired, requesting new from provider`, null, utils_1.logFormatter);
                this.token = yield this.provider.getToken(requestId);
            }
            else {
                this.logger.trace(requestId, `Using token from cache`, null, utils_1.logFormatter);
            }
            return this.token;
        });
    }
    /**
     * Gets a value indicating whether a token has already expired.
     * @param token Token to check if has expired.
     */
    hasExpired(token) {
        const now = new Date().getTime();
        // We already get a new token if is less then a minute valid.
        const expires = new Date(token.expires);
        expires.setSeconds(expires.getSeconds() + 60);
        const expiresTime = expires.getTime();
        if (expiresTime > now) {
            return false;
        }
        return true;
    }
}
exports.DefaultTokenCache = DefaultTokenCache;
//# sourceMappingURL=defaultTokenCache.js.map